import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl,
  DVFormArray
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { passwordMatch } from '../../pages/user/user.util';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { AuthenticationService } from '../authentication.service';
import { InvitesService } from 'src/app/settings/invites/invites.service';
import { SharedService } from 'src/app/shared/shared.service';
declare var $;
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, AfterViewInit {
  registerationInviteForm: DVFormGroup;
  userForm: DVFormGroup;
  role: any;
  languages: any;
  countriesWithCities: any;
  country: string;
  countryRelatedCities: Array<any> = [];
  dropdownSettings: any;
  scheduleTypes = [];
  selectedItems = [];
  selectedItemsID = [];
  selected = [];
  constructor(
    private authApi: AuthenticationService,
    private invitesApi: InvitesService,
    private sharedApi: SharedService,
    private route: ActivatedRoute,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.registerationInviteForm = new DVFormGroup({
      email: new DVFormControl(null),
      roleId: new DVFormControl(null),
      invitationId: new DVFormControl(null),

      firstName: new DVFormControl(null, {
        'FirstName is required': Validators.required
      }),
      lastName: new DVFormControl(null, {
        'LastName is required': Validators.required
      }),
      birthdate: new DVFormControl(null, {
        'Birthdate is required': Validators.required
      }),

      cityId: new DVFormControl(null, {
        'city is required': Validators.required
      }),

      languages: new DVFormControl([], {
        'Languages is required': Validators.required
      }),
      password: new DVFormControl(null),
      user: new DVFormGroup({
        password: new DVFormControl(null, {
          'This field is required': Validators.required,
          'This password must have at least 1 lower case and 1 upper case and ends with special character ': Validators.pattern(
            /[a-zA-Z\d@$!%*?&]{8,30}/
          )
        }),
        password_repeat: new DVFormControl(null, {
          'This field is required': Validators.required
        })
      })
    });

    this.invitesApi
      .invitationExist(this.route.snapshot.params.token)
      .subscribe(
        Response => {
          // console.log(Response)
          this.registerationInviteForm.controls.email.setValue(
            Response.data.invitation.email
          );
          this.registerationInviteForm.controls.roleId.setValue(
            Response.data.invitation.roleId
          );
          this.registerationInviteForm.controls.invitationId.setValue(
            Response.data.invitation.id
          );
        },
        error => {
          this.notifier.error(
            'Invitation Link is Invalid , Please check with the sender '
          );
          this.router.navigateByUrl('/login');
        }
      );
    this.sharedApi.getRoles().subscribe((res: any) => {
      this.role = res.data.roles;
      this.role = this.role.filter(x => x.assignable === true);
    });
    this.dropdownSettings = {
      dataIdProperty: 'id',
      dataNameProperty: 'name',
      headerText: 'Select Languages',
      noneSelectedBtnText: 'No Selection',
      btnWidth: '200px',
      dropdownHeight: '200px',
      showDeselectAllBtn: true,
      showSelectAllBtn: true,
      selectAllBtnText: 'Select',
      btnClasses: 'btn btn-primary btn-sm dropdown-toggle form-control',
      selectionLimit: 5,
      enableFilter: true
    };
    this.sharedApi.languages().subscribe((res: any) => {
      this.languages = [];
      res.data.languages.forEach(element => {
        this.languages.push({
          id: element.code,
          name: element.name,
          displayName: element.name
        });
      });

    });
    this.sharedApi.getAllCountries().subscribe((res: any) => {
      this.countriesWithCities = res.data.countries;
    });
  }

  ngOnInit() {
    this.userForm = this.registerationInviteForm.controls.user as DVFormGroup;
    this.registerationInviteForm.controls.user.setAsyncValidators(
      passwordMatch()
    );
  }
  ngAfterViewInit() {
    $('.preloader').fadeOut();
  }
  registerInvite() {
    this.registerationInviteForm.controls.languages.setValue(
      this.selectedItemsID
    );
    const value = this.registerationInviteForm.value;
    value.languages = this.selectedItemsID;
    if (this.registerationInviteForm.valid) {
      this.registerationInviteForm.controls.password.setValue(
        this.registerationInviteForm.get('user.password').value
      );
      delete this.registerationInviteForm.value.user;
      this.authApi.register(this.registerationInviteForm.value).subscribe(
        Response => {
          this.notifier.success('Invitation Registered Successfully');
          this.registerationInviteForm.reset();
          this.router.navigateByUrl('/login');
        },
        error => {
          this.notifier.error(error.error.userMessage);
        }
      );
    } else {
      this.registerationInviteForm.forceShowErrors();
    }
  }
  getFormArray(key): Array<any> {
    return (<DVFormArray> this.registerationInviteForm.controls[key]).controls;
  }
  getCities(event) {
    this.sharedApi.getAllCities(event.target.value).subscribe((Response) => {
       this.countryRelatedCities = Response.data.cities;
    });
  }
  onSelectedOperation(event) {
    if (event.operation === 'added') {
      if (event.item.name && event.item.id) {
        this.selectedItems.push(event.item.name);
        this.selectedItemsID.push(event.item.id);
        this.selected.push({ id: event.item.id, name: event.item.name });
      }
    } else {
      const index = this.selectedItems.findIndex(x => x.name === event.item.id);
      const idIndex = this.selectedItemsID.findIndex(
        x => x.id === event.item.name
      );
      this.selectedItems.splice(index, 1);
      this.selectedItemsID.splice(idIndex, 1);
    }
  }
}

export interface InviteRegisteration {
  email: string;
  password: string;
  roleId: number;
  invitationId: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  birthdate: string;
  cityId: number;
  languages: string[];
}
